import React from 'react';
import { Box } from '@mui/material';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 3,
  slidesToScroll: 1,
  pauseOnHover: true,
  responsive: [
    { breakpoint: 1535, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 1300, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 900, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 1 } },
  ],
};

const BannerCarousel = ({ items, renderItem, settings, containerSx }) => {
  if (!items || items.length === 0) return null;

  const mergedSettings = { ...sliderSettings, ...settings };

  return (
    <Box sx={{ width: '100%',scrollbarWidth: 'none', overflow: 'hidden', '& .slick-list': { overflow: 'hidden' }, ...containerSx }}>
      <Slider {...mergedSettings}>
        {items.map((item, idx) => renderItem(item, idx))}
      </Slider>
    </Box>
  );
};

export default BannerCarousel;
